// extracted by mini-css-extract-plugin
module.exports = {"burger":"header_burger__2by05","navbar":"header_navbar__k7HEV","right":"header_right__1vo0Q","logo":"header_logo__honNc"};